/**
 * Operator ATTOM tax assessor status diagnostics.
 * Endpoint is not yet in the generated SDK.
 */

import { client } from "@/hera-api/client/client.gen";

export interface AttomTaxAssessorExtractDateSummary {
  extract_date: string;
  record_count: number;
  jurisdiction_count: number;
}

export interface AttomTaxAssessorStateSummary {
  state: string;
  record_count: number;
  jurisdiction_count: number;
}

export interface AttomTaxAssessorStateOverTime {
  extract_date: string;
  state: string;
  record_count: number;
  jurisdiction_count: number;
}

export interface AttomTaxAssessorStatusResponse {
  state_filter: string | null;
  max_extract_dates: number;
  extract_dates_scanned: number;
  latest_extract_date: string | null;
  by_extract_date: AttomTaxAssessorExtractDateSummary[];
  latest_by_state: AttomTaxAssessorStateSummary[];
  by_state_over_time: AttomTaxAssessorStateOverTime[];
  supported_states: string[];
}

export interface AttomIntegrationStatusResponse {
  athena_configured: boolean;
  configuration_error: string | null;
  jurisdiction_foreclosure_cases_count: number;
  credentials_hint: string;
  dashboard_path: string;
}

export async function getAttomIntegrationStatus(): Promise<AttomIntegrationStatusResponse> {
  const result = await client.get<AttomIntegrationStatusResponse>({
    url: "/operator/attom/integration-status",
    parseAs: "json",
    security: [{ scheme: "bearer", type: "http" }],
  });

  if (result.error) {
    const err = result.error as { detail?: string; message?: string };
    throw new Error(
      err.detail ?? err.message ?? "Failed to load ATTOM integration status",
    );
  }

  return result.data as AttomIntegrationStatusResponse;
}

export async function getAttomTaxAssessorStatus(options?: {
  state?: string;
  maxDates?: number;
}): Promise<AttomTaxAssessorStatusResponse> {
  const query: Record<string, string | number> = {};
  if (options?.state) {
    query.state = options.state;
  }
  if (options?.maxDates != null) {
    query.max_dates = options.maxDates;
  }

  const result = await client.get<AttomTaxAssessorStatusResponse>({
    url: "/operator/attom/tax-assessor-status",
    query,
    parseAs: "json",
    security: [{ scheme: "bearer", type: "http" }],
  });

  if (result.error) {
    const err = result.error as { detail?: string; message?: string };
    throw new Error(
      err.detail ?? err.message ?? "Failed to load ATTOM tax assessor status",
    );
  }

  return result.data as AttomTaxAssessorStatusResponse;
}
